module.exports = __webpack_public_path__ + "static/media/Eileen Li.4ce69132.png";